import React from 'react';

const statusMap = {
    Active: {
        label: "Serviço",
        color: "#3b82f6", 
    },
    Unactive: {
        label: "Ausente",
        color: "#6b7280", 
    },
    Holidays: {
        label: "Férias",
        color: "#ca8a04", 
    },
    WorkTrip: {
        label: "Viagem",
        color: "#8b5cf6", 
    },
    Meeting: {
        label: "Reunião",
        color: "#6366f1",
    },
    CoffeeBreak: {
        label: "Pausa",
        color: "#d97706",
    },
    LunchBreak: {
        label: "Almoço",
        color: "#f97316",
    },
    DayOff: {
        label: "Folga",
        color: "#ef4444", 
    },
};

const StatusBadge = ({ status }) => {
    const { label, color } = statusMap[status] || { 
        label: status || "Desconhecido", 
        color: "var(--gray-400)" 
    };

    return (
        <div 
            className="shadow-sm d-flex align-items-center justify-content-center"
            style={{
                backgroundColor: color,
                padding: "6px 14px",
                borderRadius: "6px", 
                fontWeight: "600",
                color: "white",
                minWidth: "85px",
                fontSize: "0.75rem",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
            }}
        >
            {label}
        </div>
    );
};

export default StatusBadge;